import {Link} from 'react-router-dom';
import React/*, {useState}*/ from 'react';

import {useracc, postApi, putApi, deleteApi} from '../utils/functions';
import {UserContext} from '../utils/usercontext';
import EventEmitter from '../utils/emmiter';
//import Genres from './components/genres/genres';
//import AudioBox from './components/audio/audiobox';
import moment from 'moment';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import './components/fontawesome/fontawesome';

//import { Swiper, SwiperSlide } from 'swiper/react';
//import { Autoplay, Pagination, Navigation } from "swiper";
//import 'swiper/css';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import DropdownButton from 'react-bootstrap/DropdownButton';
import Dropdown from 'react-bootstrap/Dropdown';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Button from 'react-bootstrap/Button';

//import './css/index.css';
//import './css/header.css';

export default class SupportLogs extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {
			status: false,
			logs: [],
			filenames: [],
			servers: [],
			/*websites: [],
			ips: [],
			ip: '',*/
			sort: {
				column: '',
				order: ''
			}
		};
		/*this.getWebsites = this.getWebsites.bind(this);
		this.updateWebsite = this.updateWebsite.bind(this);
		this.ipaddressAdd = this.ipaddressAdd.bind(this);
		this.ipaddressRemove = this.ipaddressRemove.bind(this);*/
		
	
	
  };

  async componentDidMount() {
		//document.title = "Mix365 Radio - your music station streaming 24/7";
		const value = this.context;
		const getUser = await useracc();
		value.setUser( getUser );
		value.setTheme( '/themes/default-dark.css' );
		EventEmitter.emit('/client', {data: 'no value'});

		//this.getWebsites();

		

		//this.setState({status: true});
		//this.enable();

		this.getLogs();

	}

	componentWillUnmount() {
	}


	async getLogs(column = 'l.ctime', order = 'DESC') {
		let sort = this.state.sort;
		sort.column = column;
		sort.order = order;
		let params = new URLSearchParams();
		params.append('column', column);
		params.append('order', order);
		const x = await postApi('/v3/support/logs', params);
		if( x.status === 200 ) this.setState({status: true, logs: x.data.logs, filenames: x.data.filenames, servers: x.data.servers, sort});
	}

	render() {
		
		const logs = this.state.logs.map((e,i) => {
			return (
				<tr key={i}>
					<td>
						<Row>
							<Col xs={12}>
								<span className="badge bg-primary-transparent">{moment(e.ctime).format("DD MMM YYYY - h:mm A")}</span>
							</Col>
							<Col xs={12} className="pt-3 pb-3">
								<div className="">
									{e.filename}
								</div>
							</Col>
							<Col xs={12}>
								<div className="d-flex align-items-center">
									<div className="avatar avatar-sm me-2 avatar-rounded">
										<img src="https://laravelui.spruko.com/velvet/build/assets/images/faces/10.jpg" alt="img" />
									</div>
									<div>
										<div className="lh-1">
											<span>{e.server>0?e.subdomain:'api.ultrastream.io'}</span>
										</div>
										<div className="lh-1">
											<span className="fs-11 text-muted">ID: {e.id}</span>
										</div>
									</div>
								</div>
							</Col>
						</Row>
					</td>
					<td>
						<pre style={{whiteSpace: 'pre-wrap'}}>
							{e.log}
						</pre>
					</td>
				</tr>
			)
		})

		const filenames = this.state.filenames.map((e,i) => {
			return (
				<Dropdown.Item key={i} eventKey={i} onClick={()=>this.getLogs('l.filename', e.filename)}>{e.filename}</Dropdown.Item>
			)
		});

		const servers = this.state.servers.map((e,i) => {
			return (
				<Dropdown.Item key={i} eventKey={i} onClick={()=>this.getLogs('l.server', e.server)}>{e.subdomain}</Dropdown.Item>
			)
		});

		return (
			<>

				<div className="d-sm-flex d-block align-items-center justify-content-between page-header-breadcrumb">
					<h4 className="fw-medium mb-0">System</h4>
					<div className="ms-sm-1 ms-0">
						<nav>
							<ol className="breadcrumb mb-0">
								{/*<li className="breadcrumb-item"><a href="javascript:void(0);">Ui Elements</a></li>*/}
								<li className="breadcrumb-item active" aria-current="page">System</li>
							</ol>
						</nav>
					</div>
				</div>

				{this.state.status &&
					<div className="main-content app-content">
						 
						<div className="container-fluid">

							<div className="my-4">
								<Row>
									
									<Col xs={12}>
										<div className="row row-cols-xxl-5 row-cols-xl-3 row-cols-md-2">
											<div className="col card-background flex-fill">
												<div className="card custom-card">
													<div className="card-body">
														<div className="d-flex">
															<div>
																<p className="fw-medium mb-1 text-muted">Total Sales</p>
																<h3 className="mb-0">$18,645</h3>
															</div>
															<div className="avatar avatar-md br-4 bg-primary-transparent ms-auto">
																<i className="bi bi-cart-check fs-20"></i>
															</div>
														</div>
														<div className="d-flex mt-2">
															<span className="badge bg-primary-transparent rounded-pill">+24% <i className="fe fe-arrow-down"></i></span>
															<a href="javascript:void(0);" className="text-muted fs-11 ms-auto text-decoration-underline mt-auto">view more</a>
														</div>
													</div>
												</div>
											</div>
											<div className="col card-background flex-fill">
												<div className="card custom-card">
													<div className="card-body">
														<div className="d-flex">
															<div>
																<p className="fw-medium mb-1 text-muted">Total Revenue</p>
																<h3 className="mb-0">$34,876</h3>
															</div>
															<div className="avatar avatar-md br-4 bg-secondary-transparent ms-auto">
																<i className="bi bi-archive fs-20"></i>
															</div>
														</div>
														<div className="d-flex mt-2">
															<span className="badge bg-success-transparent rounded-pill">+0.26% <i className="fe fe-arrow-down"></i></span>
															<a href="javascript:void(0);" className="text-muted fs-11 ms-auto text-decoration-underline mt-auto">view more</a>
														</div>
													</div>
												</div>
											</div>
											<div className="col card-background flex-fill">
												<div className="card custom-card">
													<div className="card-body">
														<div className="d-flex">
															<div>
																<p className="fw-medium text-muted mb-1">Total Products</p>
																<h3 className="mb-0">26,231</h3>
															</div>
															<div className="avatar avatar-md br-4 bg-info-transparent ms-auto">
																<i className="bi bi-handbag fs-20"></i>
															</div>
														</div>
														<div className="d-flex mt-2">
															<span className="badge bg-danger-transparent rounded-pill">+06% <i className="fe fe-arrow-down"></i></span>
															<a href="javascript:void(0);" className="text-muted fs-11 ms-auto text-decoration-underline mt-auto">view more</a>
														</div>
													</div>
												</div>
											</div>
											<div className="col card-background flex-fill">
												<div className="card custom-card">
													<div className="card-body">
														<div className="d-flex">
															<div>
																<p className="fw-medium mb-1 text-muted">Total Expenses</p>
																<h3 className="mb-0">$73,579</h3>
															</div>
															<div className="avatar avatar-md br-4 bg-warning-transparent ms-auto">
																<i className="bi bi-currency-dollar fs-20"></i>
															</div>
														</div>
														<div className="d-flex mt-2">
															<span className="badge bg-success-transparent rounded-pill">+10% <i className="fe fe-arrow-up"></i></span>
															<a href="javascript:void(0);" className="text-muted fs-11 ms-auto text-decoration-underline mt-auto">view more</a>
														</div>
													</div>
												</div>
											</div>
											<div className="col card-background flex-fill">
												<div className="card custom-card">
													<div className="card-body">
														<div className="d-flex">
															<div>
																<p className="fw-medium text-muted mb-1">Active Subscribers</p>
																<h3 className="mb-0">1,468</h3>
															</div>
															<div className="avatar avatar-md br-4 bg-danger-transparent ms-auto">
																<i className="bi bi-bell fs-20"></i>
															</div>
														</div>
														<div className="d-flex mt-2">
															<span className="badge bg-danger-transparent rounded-pill">+16% <i className="fe fe-arrow-down"></i></span>
															<a href="javascript:void(0);" className="text-muted fs-11 ms-auto text-decoration-underline mt-auto">view more</a>
														</div>
													</div>
												</div>
											</div>
										</div>
									</Col>

									<Col xs={12}>
										
										<div className="card custom-card overflow-hidden">
											<div className="card-header flex-between justify-content-between">
												<div className="card-title">System Logs</div>
											</div>
											<div className="card-body">
												
												<ButtonGroup size="sm">
													<Button variant="light" onClick={()=>this.getLogs('l.ctime', this.state.sort.order==='DESC'?'ASC':'DESC')}>Time&nbsp;
														{this.state.sort.column === 'l.ctime' &&
															<FontAwesomeIcon icon={this.state.sort.order==='DESC'?'angle-down':'angle-up'} />
														}
													</Button>

													<DropdownButton as={ButtonGroup} title="Filename" id="bg-nested-dropdown" variant="light">
														{filenames}
													</DropdownButton>

													<DropdownButton as={ButtonGroup} title="Servers" id="bg-nested-dropdown" variant="light">
														{servers}
													</DropdownButton>

													
												</ButtonGroup>
												<div className="table-responsive">
													<table className="table text-nowrap table-hover">
														<thead>
															<tr>
																<th scope="col">Time  - Filename - Server</th>
																<th scope="col">Error</th>
															</tr>
														</thead>
														<tbody>
															{logs}
														</tbody>
													</table>
												</div>
											</div>
										</div>
									</Col>
								</Row>
							</div>
						</div>
					</div>
				}
			</>
		);
	}
}
